import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BackendConfiguration} from '@application/configuration/backend-configuration';
import {AdvancedSearchUtils} from '@application/helper/advanced-search-utils';
import {PropertyValue} from '@domain/property-value';
import {TechnicalDatasheet} from '@domain/technical-datasheet/technical-datasheet';
import {TuftTechnicalDatasheet} from '@domain/technical-datasheet/tuft-technical-datasheet';
import {map} from 'lodash-es';
import {Observable} from 'rxjs';
import {map as rxjsMap, retry} from 'rxjs/operators';
import {TechnicalDatasheets} from './technical-datasheets';

@Injectable()
export class HttpDatasheetsService implements TechnicalDatasheets {
  private httpClient: HttpClient;
  private backendConfiguration: BackendConfiguration;

  public constructor(httpClient: HttpClient, backendConfiguration: BackendConfiguration) {
    this.httpClient = httpClient;
    this.backendConfiguration = backendConfiguration;
  }

  public get(start: number, count: number, advancedSearchFilters: PropertyValue[]): Observable<TechnicalDatasheet[]> {
    return this.httpClient
      .post(`${this.backendConfiguration.getEndpoint()}technicaldatasheet/get?start=${start}&count=${count}`, AdvancedSearchUtils.getAgGridJsonBodyForAdvancedSearchFilters(advancedSearchFilters))
      .pipe(rxjsMap(this.mapDatasheetsJSONToList));
  }

  public getThumbnail(id: number): Observable<Blob> {
    return this.httpClient.get(`${this.backendConfiguration.getEndpoint()}technicaldatasheet/${id}/thumbnail`, {responseType: 'blob'}).pipe(retry(2));
  }

  public getById(id: number): Observable<TuftTechnicalDatasheet> {
    return this.httpClient
      .get(`${this.backendConfiguration.getEndpoint()}tufttechnicaldatasheet/${id}`)
      .pipe(rxjsMap((tuftTechnicalDatasheetJSON: any) => TuftTechnicalDatasheet.fromJSON(tuftTechnicalDatasheetJSON)));
  }

  public getXmlForDatasheet(id: number): Observable<string> {
    return this.httpClient.get(`${this.backendConfiguration.getEndpoint()}tufttechnicaldatasheet/${id}/xml`, {responseType: 'text'});
  }

  public getXSLTForDatasheet(id: number): Observable<string> {
    return this.httpClient.get(`${this.backendConfiguration.getEndpoint()}tufttechnicaldatasheet/${id}/xslt`, {responseType: 'text'});
  }

  public delete(id: number): Observable<void> {
    return this.httpClient.delete<void>(`${this.backendConfiguration.getEndpoint()}tufttechnicaldatasheet/${id}`);
  }

  private mapDatasheetsJSONToList(datasheetsJSON: any): TechnicalDatasheet[] {
    return map(datasheetsJSON, (datasheetJSON: any) => {
      return TechnicalDatasheet.fromJSON(datasheetJSON);
    });
  }
}
